import notInter from '../util/notInter';

export default {
  init() {
    notInter()
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
